import { createContext, ReactNode, useContext, useMemo } from 'react'
import { ExerciseStore } from './dto.store'
import { useExerciseFilterStore } from './filters.provider'
import { ExerciseFilterStore } from './filters.store'

export const ExercisesStoreContext = createContext<null | ExerciseStore>(null)

export const useExercisesStore = (): ExerciseStore => {
	const store: ExerciseStore | null = useContext(ExercisesStoreContext)
	if (!store) {
		throw new Error('useExercisesStore must be used within a ExercisesStoreProvider.')
	}
	return store
}

export const ExercisesStoreProvider = ({ children }: { children: ReactNode }) => {
	const filtersStore: ExerciseFilterStore = useExerciseFilterStore()
	const store: ExerciseStore = useMemo(() => new ExerciseStore(filtersStore), [])

	return <ExercisesStoreContext.Provider value={store}>{children}</ExercisesStoreContext.Provider>
}
